/**
 * Virtual skill development programmes (4 weeks, ages 13-18).
 *
 * Source: https://alearninglab.com/virtual-skill-development-programs/ (Batch 1, 12-15 October 2026).
 * ONLY ACTIVE PROGRAMMES ARE LISTED. The Elementor page also holds containers that are hidden on every
 * device (AI & Future Tech, Passion Project, Management Consulting, Venture Capital, Debating & Public
 * Speaking). They are not live on the old site, so they are deliberately left out here. To bring one back,
 * un-hide it on the old site first, then add it below.
 *
 * Raw program shape, so it goes through `normalizeProgram` in src/lib/programs.js like backend data.
 * `industry` is an id from src/data/industries.js and decides which industry page lists the programme.
 * `enrolUrl` / `url` are the live “Book Now” payment links (alearninglab.com/payments?program_id=…), keyed by backend id in SKILL_BOOKING_BY_API_ID.
 * Fees, times and dates are what the live site shows today; confirm against the backend before launch.
 *
 * Thumbnails reuse illustrations from related programmes on alearninglab.com (the skill page has no
 * programme images of its own); replace with dedicated artwork when available.
 */

const UP = (path) => `https://alearninglab.com/wp-content/uploads/${path}`;
const ARCHITECTURE_IMAGE = "https://alearninglab.com/wp-content/uploads/2026/04/closeup-collaborative-han_2741210700-scaled.webp";

const PAYMENTS = "https://alearninglab.com/payments?program_id=";
const KIND = "Skill development";
const BATCH = "12 – 15 Oct 2026";

/** Backend `/programs` id → Book Now URL on alearninglab.com (Batch 1, live skill page). */
export const SKILL_BOOKING_BY_API_ID = {
  339: `${PAYMENTS}222`, // Microsoft Excel Workshop
  340: `${PAYMENTS}223`, // Financial Statements Workshop
  341: `${PAYMENTS}221`, // International Competitive Writing
  342: `${PAYMENTS}217`, // Art and Design Portfolio Builder
};

function skill(partial) {
  const enrolUrl = partial.enrolUrl || SKILL_BOOKING_BY_API_ID[partial.apiId];
  return {
    mode: "Virtual",
    duration: "4 Weeks",
    price: 300,
    currency: "USD",
    kind: KIND,
    ages: "13-18",
    ...partial,
    enrolUrl,
    url: enrolUrl,
    id: `skill-${partial.slug}`,
    startDate: `${BATCH} · ${partial.time}`,
  };
}

export const SKILL_PROGRAMS = [
  skill({
    slug: "microsoft-excel-workshop",
    apiId: 339,
    industry: "finance",
    title: "Microsoft Excel Workshop",
    summary:
      "Master spreadsheet fundamentals: formulas, functions, data organisation, charts, pivot tables, conditional formatting and real-world data analysis. Practical skills used in business, finance and academia.",
    thumbnail: UP("2026/01/Frame-1707483320.png"),
    time: "3PM – 5PM GST",
  }),
  skill({
    slug: "financial-statements-workshop",
    apiId: 340,
    industry: "finance",
    title: "Financial Statements Workshop",
    summary:
      "Learn to read, interpret and analyse the three core financial statements: income statement, balance sheet and cash flow. Understand ratios, profitability and how businesses make financial decisions.",
    thumbnail: UP("2025/12/Frame-1707483293.png"),
    time: "12PM – 2PM GST",
  }),
  skill({
    slug: "art-and-design-portfolio-builder",
    apiId: 342,
    industry: "ui-ux-creative-designing",
    title: "Art and Design Portfolio Builder",
    summary:
      "Create a competitive portfolio in 4 sessions: self-portrait, observational drawing, typography, sketchbook development, photography, 3D and spatial design, and final curation with an artist statement.",
    thumbnail: ARCHITECTURE_IMAGE,
    time: "1PM – 3PM GST",
  }),
  skill({
    slug: "international-competitive-writing",
    apiId: 341,
    industry: "law-public-policy-global-affairs",
    title: "International Competitive Writing",
    summary:
      "Write and compete across personal essays, short fiction, poetry, opinion writing and long-form journalism. Develop your own voice and submit polished, competition-ready pieces.",
    thumbnail: UP("2026/01/Frame-1707483313.png"),
    time: "5PM – 7PM GST",
  }),
];
